import { render, staticRenderFns } from "./BaseModal.vue?vue&type=template&id=fa4cfa64&scoped=true"
import script from "./BaseModal.vue?vue&type=script&lang=js"
export * from "./BaseModal.vue?vue&type=script&lang=js"
import style0 from "./BaseModal.vue?vue&type=style&index=0&id=fa4cfa64&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4cfa64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa4cfa64')) {
      api.createRecord('fa4cfa64', component.options)
    } else {
      api.reload('fa4cfa64', component.options)
    }
    module.hot.accept("./BaseModal.vue?vue&type=template&id=fa4cfa64&scoped=true", function () {
      api.rerender('fa4cfa64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/investments/model-list-manager/BaseModal.vue"
export default component.exports